import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function GradientWaveTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug overflow-hidden" data-testid="resume-live-preview">
      <div className="relative h-32 flex flex-col justify-center px-8" style={{ background: `linear-gradient(135deg, ${accent} 0%, ${accent}99 100%)` }}>
        <h1 className="text-2xl font-bold text-white">{draft.full_name || "Your Name"}</h1>
        {draft.target_role && <p className="text-white/85 text-sm font-medium mt-0.5">{draft.target_role}</p>}
        <p className="text-white/75 text-[11px] mt-1.5">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
        <svg className="absolute bottom-0 left-0 w-full" height="20" viewBox="0 0 400 20" preserveAspectRatio="none"><path d="M0 20 Q100 0 200 20 T400 20 V20 H0 Z" fill="white" /></svg>
      </div>
      <div className="px-8 pb-8 pt-2">
        {draft.skills.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mb-4">
            {draft.skills.map((sk) => <span key={sk} className="text-[11px] font-semibold px-2.5 py-1 rounded-full" style={{ backgroundColor: `${accent}15`, color: accent }}>{sk}</span>)}
          </div>
        )}
        {draft.summary && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Summary</h2>
            <p className="text-slate-700 mt-1">{draft.summary}</p>
          </div>
        )}
        {draft.experience.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Experience</h2>
            {draft.experience.map((e, i) => (
              <div key={i} className="mt-2">
                <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
              </div>
            ))}
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Education</h2>
            {draft.education.map((ed, i) => <p key={i} className="text-slate-700 mt-1"><span className="font-semibold text-slate-800">{ed.degree} {ed.field}</span> — {ed.school}</p>)}
          </div>
        )}
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
